import appLocaleData from "react-intl/locale-data/de";
import enMessages from "../locales/de-de";

const DeLang = {
  messages: {
    ...enMessages
  },
  locale: "de-de",
  data: appLocaleData
};
export default DeLang;
